import { Tile } from "../tile/Tile";
import { metricTileNote, metricTileValue } from "./MetricTile.css";

export interface MetricTileProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "title"
> {
  /** Short metric label (e.g. "Running now"). */
  name: string;
  /** Headline value displayed prominently. */
  value: string;
  /** Optional note rendered beneath the value. */
  note?: string;
}

export function MetricTile({
  name,
  value,
  note,
  className,
  ...props
}: MetricTileProps) {
  return (
    <Tile className={className} {...props} title={name}>
      <p className={metricTileValue}>{value}</p>
      {note && (
        <p className={metricTileNote} title={note}>
          {note}
        </p>
      )}
    </Tile>
  );
}
